import audienceApi from '@/api/audience'
import countingApi from '@/api/counting'
import * as Sentry from '@sentry/vue'

const createOrUpdateAudienceAction = async ({ commit, dispatch }, payload) => {
  try {
    const audience = await audienceApi.createOrUpdateAudience(payload)
    commit('setAudience', audience)
    dispatch('audienceCountJoinPresentationAction')
  } catch (error) {
    Sentry.captureException(error)
  }
}
const setAudienceIdAction = ({ commit }, audienceId) => {
  commit('setAudienceId', audienceId)
}

const setQuestionerName = ({ commit }, name) => {
  commit('setQuestionerName', name)
}

const audienceJoinPresentationAction = async (_, payload) => {
  try {
    return await audienceApi.audienceJoinPresentation(payload)
  } catch (error) {
    Sentry.captureException('Audience Join Presentation Error', {
      extra: {
        error,
        payload,
      },
    })
  }
  return null
}

const audienceCountJoinPresentationAction = async ({ state, rootGetters }) => {
  if (!rootGetters['featureToggles/canUseEveryoneHasAnswered']) return
  try {
    const countingPayload = {
      counts: [
        {
          bucket: `presentation-${state.presentation.id}`,
          key: `everyone-answered-joined-${state.presentation.version}`,
          item: `everyone-answered-audience-${state.audienceId}`,
        },
      ],
    }
    await countingApi.sendCountingUnique(countingPayload)
  } catch (error) {
    Sentry.captureException('Audience Join Counting Presentation Error', {
      extra: {
        error,
      },
    })
    // do nothing
  }
}

const audienceCountAnsweredSlideAction = async ({ state, getters }) => {
  if (!getters['featureToggles/canUseEveryoneHasAnswered']) return
  try {
    const countingPayload = {
      counts: [{
        bucket: `presentation-${state.presentation.id}`,
        key: `everyone-answered-answer-${getters.activeActivity.id}-${getters.activeActivity.version}`,
        item: `everyone-answered-audience-${state.audienceId}`,
      }],
    }
    countingApi.sendCountingUnique(countingPayload)
  } catch (error) {
    Sentry.captureException('Audience Answered Counting Presentation Error', {
      extra: {
        error,
      },
    })
    // do nothing
  }
}

export default {
  setAudienceIdAction,
  setQuestionerName,
  createOrUpdateAudienceAction,
  audienceJoinPresentationAction,
  audienceCountJoinPresentationAction,
  audienceCountAnsweredSlideAction,
}
